import { Card, CardContent, Box, Typography } from "@mui/material";

export default function CombinedCard({ title, dotacion, cobertura, holgura, t }) {
	return (
		<Card
			variant="outlined"
			sx={{
				borderRadius: "16px",
				border: "1px solid",
				borderColor: "divider",
			}}
		>
			<CardContent>
				{/* Título + ícono con tooltip */}
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						mb: 1,
						gap: 1,
					}}
				>
					<Typography variant="h6" align="center">
						{title}
					</Typography>
				</Box>

				{/* Contenido actual */}
				<Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
					<Typography variant="body1">{t("new_charts.staffing")}</Typography>
					<Typography variant="body1">{dotacion}</Typography>
				</Box>
				<Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
					<Typography variant="body1">{t("aux.coverage")}</Typography>
					<Typography variant="body1">{cobertura.toFixed(2)} %</Typography>
				</Box>
				<Box sx={{ display: "flex", justifyContent: "space-between" }}>
					<Typography variant="body1">{t("aux.holgura")}</Typography>
					<Typography variant="body1">{holgura.toFixed(2)} %</Typography>
				</Box>
			</CardContent>
		</Card>
	);
}
